import React from 'react';

const UseCaseSelector = ({ description, onDescriptionChange }) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Collateral Description</h3>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Describe the collateral you need
        </label>
        <textarea
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          maxLength={20000}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
          placeholder="Enter a description of the collateral required (e.g., 'A competitive battle card comparing our product with competitors', 'A product one-pager highlighting key features', etc.)"
          rows={4}
        />
        <div className="mt-2 text-xs text-gray-500 text-right">
          {description.length} / 20,000 characters
        </div>
      </div>
    </div>
  );
};

export default UseCaseSelector;
